import { compose } from 'redux';
import { connect } from 'react-redux';
import { selectActiveVenueId, selectUserInfo, selectSchedulesStartDate } from 'selectors/general';
import { withOpportunityShownTracking } from 'helpers/events';
import { selectIsDesktop } from 'selectors/ui';

import { selectActiveScheduleDetailTab } from '../YieldManagement.selectors';
import { actOnOpportunityFromSchedule as actOnOpportunityFromScheduleAction, addSpot } from '../YieldManagement.saga';

import ScheduleListItem from './ScheduleListItem';

const ADD_SPOT_VALUE = 1;
function mapStateToProps(state, ownProps) {
  const venueId = selectActiveVenueId(state);
  const startDate = selectSchedulesStartDate(state);
  const tab = selectActiveScheduleDetailTab(state);
  const user = selectUserInfo(state);
  const { userId } = user;

  return {
    ...ownProps,
    venueId,
    startDate,
    tab,
    isDesktop: selectIsDesktop(state),
    userId,
  };
}

const mapDispatchToProps = {
  actOnOpportunity: actOnOpportunityFromScheduleAction,
  handleAddSpot: addSpot,
};

function mergeProps(stateProps, dispatchProps) {
  const { venueId, schedule } = stateProps;
  const { opportunity, scheduleId, scheduleName: className, spots, startDateTime, smartspotEnabled } = schedule || {};
  const { classpassTotal } = spots || {};

  const { actOnOpportunity, handleAddSpot } = dispatchProps;

  return {
    ...stateProps,
    actOnOpportunity: actOnOpportunity.bind(null, {
      venueId,
      schedule,
      opportunities: opportunity ? [opportunity] : [],
      spotsAdded: opportunity && opportunity.recommendation,
      className,
      startDateTime,
      source: 'schedule list',
    }),
    handleAddSpot: () => handleAddSpot(classpassTotal, scheduleId, classpassTotal + ADD_SPOT_VALUE, smartspotEnabled),
  };
}

export default compose(
  withOpportunityShownTracking,
  connect(mapStateToProps, mapDispatchToProps, mergeProps)
)(ScheduleListItem);
